export enum PaymentTypeEnum {
  ACH,
  CREDIT,
  DEBIT
}
